import * as Dialog from "@radix-ui/react-dialog";
import { XMarkIcon } from "components/icons/outline";

type DeleteCommentModalProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    onDelete: () => void;
};

export const DeleteCommentModal = ({ isOpen, setIsOpen, onDelete }: DeleteCommentModalProps) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />

                <Dialog.Content className="fixed top-1/2 left-1/2 z-50 w-full max-w-xs -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-lg shadow-lg">
                    <div className="relative bg-white p-2">
                        <Dialog.Close asChild>
                            <button className="absolute top-2 right-2 rounded-full p-1 text-gray-600 transition-transform duration-150 hover:text-black focus:ring-0 focus:outline-hidden">
                                <XMarkIcon className="h-4 w-4" />
                            </button>
                        </Dialog.Close>
                    </div>

                    {/* Content section */}
                    <div className="space-y-4 bg-white p-4">
                        {/* <p className="text-large font-semibold text-gray-800">
                            Are you sure you want to delete this comment?
                        </p> */}

                        <p className="text-large font-semibold text-gray-800">
                            Are you sure you want to delete this comment?
                        </p>

                        <div className="flex justify-start gap-2">
                            <button
                                className="rounded bg-[#FF3B30] px-4 py-1.5 text-sm font-medium text-white hover:bg-[#d32f27]"
                                onClick={() => {
                                    onDelete();
                                    setIsOpen(false);
                                }}
                            >
                                Continue
                            </button>
                            <Dialog.Close asChild>
                                <button className="rounded bg-gray-100 px-4 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-200">
                                    Cancel
                                </button>
                            </Dialog.Close>
                        </div>
                    </div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
